export default [{
    name: 'form-zr',
    path: '/form/zr',
    meta: {title: 'form-zr', needLogin: false},
    component: () => import('./views/zr')
}, {
    name: 'form-zc',
    path: '/form/zc',
    meta: {title: 'form-zc', needLogin: false},
    component: () => import('./views/zc')
}, {
    name: 'form-pj',
    path: '/form/pj',
    meta: {title: 'form-pj', needLogin: false},
    component: () => import('./views/pj')
},
    {
        name: 'form-sd',
        path: '/form/sd',
        meta: {title: 'form-sd', needLogin: false},
        component: () => import('./views/sd')
    },];
